import React, { useState } from 'react';
import VisitorCard from './VisitorCard';
import marketingService from '../../../services/api/marketingService';

function PipelineColumn({ stage, visitors, selectMode, selected, onToggleSelect }) {
  const [downloading, setDownloading] = useState(false);

  // Printable call sheet for the Call list column (one page per lead)
  const handleCallSheet = async (e) => {
    e.stopPropagation();
    if (downloading) return;
    setDownloading(true);
    try {
      const blob = await marketingService.downloadCallSheet();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `MarkoTM Call Sheet ${new Date().toISOString().slice(0, 10)}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      window.alert(`Call sheet download failed: ${err.message}`);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className={`mkt-column ${stage.muted ? 'mkt-column-muted' : ''}`} style={stage.muted ? { opacity: 0.8 } : undefined}>
      <div className="mkt-column-header" style={{ borderTopColor: stage.color }}>
        <span className="mkt-column-title">{stage.label}</span>
        {stage.key === 'call' && visitors.length > 0 && (
          <button
            className="mkt-btn mkt-btn-secondary"
            style={{ fontSize: '11px', padding: '2px 8px', marginLeft: '6px', whiteSpace: 'nowrap' }}
            onClick={handleCallSheet}
            disabled={downloading}
            title="Download the printable call sheet (one page per lead, max 50)"
          >
            {downloading ? '⏳…' : `📄 Call sheet (${visitors.length})`}
          </button>
        )}
        <span className="mkt-column-count">{visitors.length}</span>
      </div>
      <div className="mkt-column-body">
        {visitors.length === 0 ? (
          <div className="mkt-column-empty">No visitors</div>
        ) : (
          visitors.map((visitor) => (
            <VisitorCard
              key={visitor.id}
              visitor={visitor}
              stageColor={stage.color}
              selectMode={selectMode}
              isSelected={selected?.has(visitor.id)}
              onToggleSelect={onToggleSelect}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default PipelineColumn;
